import { useState, useEffect } from "react";
import { useApi } from "../../hooks/use-api";
import { apiAcyncQuizProgress, apiCloseRoom } from "../../utils/api-routes";
import { useSingleton } from "../../hooks/use-singleton";

export const useHandler = ({ roomCode, setShowLeaderboard }) => {
  const { get, post } = useApi();
  const { mail } = useSingleton();
  const [quizResult, setQuizResult] = useState(null);
  const [search, setSearch] = useState("");
  console.log(roomCode, "roomcode");
  // useEffect(() => {
  //   // if (roomCode) {
  //   getQuizResult();
  //   // }
  // }, []);

  useEffect(() => {
    if (!roomCode) return;

    // initial api call
    getQuizResult();

    // auto refresh every 2 sec
    const interval = setInterval(() => {
      getQuizResult();
    }, 2000);

    // cleanup
    return () => clearInterval(interval);
  }, [roomCode]);

  const getQuizResult = async () => {
    try {
      const res = await get(apiAcyncQuizProgress(roomCode));
      // const res = await get(apiAcyncQuizProgress(910536));

      console.log(res, "quiz result response");

      setQuizResult(res?.data);
    } catch (e) {
      console.log("Error on getting quiz result", e);
    }
  };

  const closeRoom = async () => {
    try {
      const res = await post(apiCloseRoom(roomCode, mail));
      // const res = await post(apiCloseRoom(910536, mail));

      console.log(res, "room closed successfully");

      // optional refresh
      // getQuizResult();
      setShowLeaderboard(true);
    } catch (e) {
      console.log("Error on closing room", e);
    }
  };

  return { quizResult, getQuizResult, search, setSearch, closeRoom };
};
